var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0477 0H5.47492C5.22242 0 4.98002 0.100382 4.80143 0.279129L0.278849 4.80544C-0.0929495 5.17755 -0.0929495 5.78094 0.278849 6.15355L3.84303 9.72097C4.02893 9.90692 4.27283 10 4.51643 10C4.75983 10 5.00322 9.90712 5.18912 9.72157L9.7202 5.19506C9.8994 5.01631 10 4.77351 10 4.52041V0.953182C10 0.42675 9.5737 0 9.0477 0ZM7.12851 4.07174C6.46622 4.07174 5.92732 3.5322 5.92732 2.86915C5.92732 2.20631 6.46622 1.66697 7.12851 1.66697C7.79131 1.66697 8.33031 2.20631 8.33031 2.86915C8.33031 3.5322 7.79131 4.07174 7.12851 4.07174Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/TagIcon.2c44cdfd855e9a30228d9e3010789da0.svg";
export { ForwardRef as ReactComponent };